export enum PalantirBadgeThemeEnum {
  'accent' = 'accent',
  light = 'light',
  'primary-soft' = 'primary-soft',
  'primary-solid' = 'primary-solid',
  surface = 'surface',
}

export type PalantirBadgeTheme = keyof typeof PalantirBadgeThemeEnum;
